/*
  Plain sentences for the incoming-postback journal (plan: stage 3). The server
  sends a reason code; the text lives here so it is translated like the rest
  of the interface.
*/

export function postbackReasonText(t, code) {
  switch (code) {
    case 'accepted':
      return t('Accepted: a new conversion was recorded.');
    case 'updated':
      return t('Accepted: the existing conversion of this click was updated.');
    case 'ignored_status':
      return t('Ignored: this status is set to be ignored in the status mapping.');
    case 'transition_blocked':
      return t('Not applied: this status change is not allowed by your conversion types (for example, from sale back to lead).');
    case 'token_invalid':
      return t('Rejected: the token in the address is wrong or belongs to another campaign. Copy the postback URL from this campaign again.');
    case 'token_missing':
      return t('Rejected: the address has no token, and this campaign requires one. Add the token from the postback URL of this campaign, or turn off token checking in this campaign only.');
    case 'ip_not_allowed':
      return t('Rejected: the sender IP is not in the allowed IP list of this campaign.');
    case 'campaign_missing':
      return t('Rejected: the campaign of this click no longer exists.');
    default:
      return t('Rejected by the tracker.');
  }
}

export function postbackOutcomeLabel(t, outcome) {
  if (outcome === 'accepted') return t('Accepted');
  if (outcome === 'ignored') return t('Ignored');
  return t('Rejected');
}
